import * as React from "react";
import axios from "axios";
import { getParam } from "./getParam";
import { MyCard } from "./MyCard";
import { DataTable, shortHash } from "./ui";

const FEE_TESTNET = "mgaw88zztsHWN8SyL9vXwiCed7aRiPwL26";
const FEE_MAINNET = "TesBmcgLQsowvYEYPXpSHkkapoTbVV7Xfe";

export function Block() {
  const hash = getParam("hash");
  const [data, setData] = React.useState<any>(null);

  React.useEffect(() => {
    if (!hash) {
      setData({ error: "Missing block hash" });
      return;
    }
    let cancelled = false;
    axios
      .get("/api/blocks/" + encodeURIComponent(hash))
      .then((r) => {
        if (cancelled) return;
        const d = r.data;
        if (d && d.error) setData({ error: d.error, hash });
        else setData(d);
      })
      .catch((e) => {
        if (!cancelled) setData({ error: e?.message || String(e), hash });
      });
    return () => {
      cancelled = true;
    };
  }, [hash]);

  if (!data) {
    return (
      <div className="page">
        <p className="muted">Loading block…</p>
      </div>
    );
  }
  if (data.error) {
    return (
      <div className="page">
        <p className="muted">Could not load block: {data.error}</p>
      </div>
    );
  }

  const txs = (data.tx || []).map((t: any) => (t.txid ? t.txid : t));

  return (
    <div className="page stack">
      <div className="kicker">Block {data.height?.toLocaleString()}</div>
      <h1 style={{ fontSize: 28, margin: "0 0 8px" }} className="mono">
        {shortHash(data.hash, 16)}
      </h1>
      <MyCard
        header="Summary"
        body={
          <dl className="kv">
            <dt>Height</dt>
            <dd>{data.height?.toLocaleString()}</dd>
            <dt>Time</dt>
            <dd>{new Date(data.time * 1000).toLocaleString()}</dd>
            <dt>Transactions</dt>
            <dd>{txs.length.toLocaleString()}</dd>
            <dt>Difficulty</dt>
            <dd>{data.difficulty}</dd>
            <dt>Size</dt>
            <dd>{data.size ? data.size.toLocaleString() + " bytes" : "—"}</dd>
            <dt>Nonce</dt>
            <dd className="mono">{data.nonce}</dd>
            <dt>Merkle root</dt>
            <dd className="mono">{data.merkleroot}</dd>
            <dt>Previous</dt>
            <dd>
              {data.previousblockhash ? (
                <a className="mono" href={"index.html?route=BLOCK&hash=" + data.previousblockhash}>
                  {shortHash(data.previousblockhash)}
                </a>
              ) : (
                "genesis"
              )}
            </dd>
          </dl>
        }
      />
      <MyCard
        header={"Transactions · " + txs.length}
        body={
          <DataTable
            headers={["#", "Txid"]}
            rows={txs.map((t: string, i: number) => [
              i,
              <a className="mono" href={"index.html?route=TRANSACTION&id=" + t}>
                {t}
              </a>,
            ])}
          />
        }
      />
      <details className="card">
        <summary className="card-h">Raw JSON</summary>
        <div className="card-b">
          <pre className="raw">{JSON.stringify(data, null, 2)}</pre>
        </div>
      </details>
    </div>
  );
}

export { FEE_TESTNET, FEE_MAINNET };
